export default {
  install: function (app, options) {
    if (!options.translate?.global?.t) {
      console.log('formsMetaData not initialized')
      return
    }

    const t = options.translate.global.t

    const formsMetaData = {
      emailRoot: 'tumor_prax_root@lxcloud.de',
      popupSizes: {
        small: {
          maxWidth: 800,
          widthPercentage: 90,
          widthMobilePhonePercentage: 90
        },
        medium: {
          maxWidth: 1400,
          widthPercentage: 90,
          widthMobilePhonePercentage: 90
        },
        large: {
          maxWidth: 2000,
          widthPercentage: 90,
          widthMobilePhonePercentage: 90
        }
      },
      iconTypes: {
        IS_ACTIVE: 'mdi-check',
        IS_INACTIVE: 'mdi-cancel',
        IS_DEAD: 'mdi-grave-stone',
        HAS_INFUSION_PROTOCOL_TEMPLATE: 'mdi-clipboard-check',
        HAS_INFUSION_PROTOCOL_EDIT: 'mdi-clipboard-edit',
        INFUSION_PROTOCOL_MISSING: 'mdi-information',
        PATIENT_SCHEMA_CLOSED: 'mdi-cancel',
        PATIENT_SCHEMA_NEW: 'mdi-new-box',
        INVITER_TYPE_ROOT: 'mdi-mace',
        INVITER_TYPE_USER: 'mdi-map-marker-radius-outline',
      },
      booleanTypes: [
        {value: true, text: t('metadata.booleanTypes.true')},
        {value: false, text: t('metadata.booleanTypes.false')}
      ],
      regexes: {
        emailSplitter: /,|;/,
        emailValidator: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
        patientInsuranceNumber: /^([A-Z])(\d{8})(\d)$/,
        time_HHMMSS: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/
      },
      titleValues: ['Dipl. Ing.', 'Dipl. Kaufm.', 'Dipl. med.', 'Dr.', 'Dr. Dr.', 'Prof.', 'Prof. Dr.'],
      titleValuesLocations: ['Dr. med.', 'Dr.', 'Prof.', 'Dr. rer. nat.'],
      namePrefixValues: ['de', 'de la', 'van', 'von', 'von der'],
      genderValues: [
        {value: 'w', text: t('metadata.genderTypes.w'), icon: 'mdi-gender-female', color: 'pink'},
        {value: 'm', text: t('metadata.genderTypes.m'), icon: 'mdi-gender-male', color: 'sky'},
        {value: 'd', text: t('metadata.genderTypes.d'), icon: 'mdi-gender-transgender', color: 'green'},
        {value: 'x', text: t('metadata.genderTypes.x'), icon: 'mdi-gender-non-binary', color: 'lime'},
        {value: 'u', text: t('metadata.genderTypes.u'), icon: 'mdi-gender-male-female-variant', color: 'orange'}
      ],
      salutationValues: [
        {value: 'w', text: t('metadata.salutationValues.w')},
        {value: 'm', text: t('metadata.salutationValues.m')},
        {value: 's', text: t('metadata.salutationValues.s')}
      ],
      insuranceStateTypes: {
        LEGAL: 'legal',
        PRIVATE: 'private',
        OTHERS: 'others'
      },
      insuranceStates: [
        {value: 'legal', text: t('metadata.insuranceStates.legal')},
        {value: 'private', text: t('metadata.insuranceStates.private')},
        {value: 'others', text: t('metadata.insuranceStates.others')}
      ],
      replacementCodeTypes: [
        {value: '970000011', text: '970000011 - Selbstzahler'},
        {value: '970001001', text: '970001001 - Kostenträger ohne IK-Nummer (z.B. Gefängnisinsassen)'},
        {value: '970100001', text: '970100001 - Asylbewerber'},
        {value: '970000022', text: '970000022 - Privatversichert, Kasse unbekannt'},
        {value: '970000099', text: '970000099 - Keine Angabe zum Kostenträger'}
      ],
      federalStateTypes: [
        {value: 'BW', text: 'Baden-Württemberg'},
        {value: 'BY', text: 'Bayern'},
        {value: 'BE', text: 'Berlin'},
        {value: 'BB', text: 'Brandenburg'},
        {value: 'HB', text: 'Bremen'},
        {value: 'HH', text: 'Hamburg'},
        {value: 'HE', text: 'Hessen'},
        {value: 'MV', text: 'Mecklenburg-Vorpommern'},
        {value: 'NI', text: 'Niedersachsen'},
        {value: 'NW', text: 'Nordrhein-Westfalen'},
        {value: 'RP', text: 'Rheinland-Pfalz'},
        {value: 'SL', text: 'Saarland'},
        {value: 'SN', text: 'Sachsen'},
        {value: 'ST', text: 'Sachsen-Anhalt'},
        {value: 'SH', text: 'Schleswig-Holstein'},
        {value: 'TH', text: 'Thüringen'}
      ],
      roles: {
        RoleBasicOrderPhysician: 'basicOrderPhysician',
        RoleBasicOrderOncologySpecialist: 'basicOrderOncologySpecialist',
        RolePhysicianUser: 'physicianUser',
        RolePhysicianOncologySpecialist: 'physicianOncologySpecialist',
        RolePhysicianPhysician: 'physicianPhysician',
        RolePhysicianGPAdmin: 'physicianGPAdmin',
        RoleUserAdmin: 'userAdmin'
      },
      partnerTypes: {
        Physician: 'physician',
        PhysicianLink: 'physician_link',
        Pharmacy: 'pharmacy',
        PharmacyLink: 'pharmacy_link',
        BasicOrder: 'basic_order'
      },
      constants: {
        unit_factor: 72,
        creatinine_factor: 88.402,
        undiluted: 'unverdünnt',
        emptyObjectId: '000000000000000000000000'
      },
      karnofskyStates: [
        {
          value: 100,
          text: 'Normalzustand, keine Beschwerden, keine manifeste Erkrankung',
          text_long: '100 - Normalzustand, keine Beschwerden, keine manifeste Erkrankung'
        },
        {
          value: 90,
          text: 'Normale Leistungsfähigkeit, minimale Krankheitssymptome',
          text_long: '90 - Normale Leistungsfähigkeit, minimale Krankheitssymptome'
        },
        {
          value: 80,
          text: 'Normale Leistungsfähigkeit mit Anstrengung, geringe Krankheitssymptome',
          text_long: '80 - Normale Leistungsfähigkeit mit Anstrengung, geringe Krankheitssymptome'
        },
        {
          value: 70,
          text: 'Eingeschränkte Leistungsfähigkeit, arbeitsunfähig, kann sich selbst versorgen',
          text_long: '70 - Eingeschränkte Leistungsfähigkeit, arbeitsunfähig, kann sich selbst versorgen'
        },
        {
          value: 60,
          text: 'Eingeschränkte Leistungsfähigkeit, benötigt gelegentlich fremde Hilfe',
          text_long: '60 - Eingeschränkte Leistungsfähigkeit, benötigt gelegentlich fremde Hilfe'
        },
        {
          value: 50,
          text: 'Eingeschränkte Leistungsfähigkeit, braucht krankenpflegerische und ärztliche Betreuung, nicht dauernd bettlägerig',
          text_long: '50 - Eingeschränkte Leistungsfähigkeit, braucht krankenpflegerische und ärztliche Betreuung, nicht dauernd bettlägerig'
        },
        {
          value: 40,
          text: 'Bettlägerig, spezielle Pflege erforderlich',
          text_long: '40 - Bettlägerig, spezielle Pflege erforderlich'
        },
        {
          value: 30,
          text: 'Schwer krank, Krankenhauspflege notwendig',
          text_long: '30 - Schwer krank, Krankenhauspflege notwendig'
        },
        {
          value: 20,
          text: 'Schwer krank, Krankenhauspflege und supportive Maßnahmen erforderlich',
          text_long: '20 - Schwer krank, Krankenhauspflege und supportive Maßnahmen erforderlich'
        },
        {
          value: 10,
          text: 'Moribund, Krankheit schreitet schnell fort',
          text_long: '10 - Moribund, Krankheit schreitet schnell fort'
        },
        {
          value: 0,
          text: 'Tot',
          text_long: '0 - Tod'
        }
      ],
      ecogStates: [
        {
          value: 0,
          text: 'Normale, uneingeschränkte Aktivität wie vor der Erkrankung (90 - 100 % nach Karnofsky)',
          text_long: '0 - Normale, uneingeschränkte Aktivität wie vor der Erkrankung (90 - 100 % nach Karnofsky)'
        },
        {
          value: 1,
          text: 'Einschränkung bei körperlicher Anstrengung, aber gehfähig; leichte körperliche Arbeit bzw. Arbeit im Sitzen (z.B. leichte Hausarbeit oder Büroarbeit) möglich (70 - 80 % nach Karnofsky)',
          text_long: '1 - Einschränkung bei körperlicher Anstrengung, aber gehfähig; leichte körperliche Arbeit bzw. Arbeit im Sitzen (z.B. leichte Hausarbeit oder Büroarbeit) möglich (70 - 80 % nach Karnofsky)'
        },
        {
          value: 2,
          text: 'Gehfähig, Selbstversorgung möglich, aber nicht arbeitsfähig; kann mehr als 50% der Wachzeit aufstehen (50 - 60 % nach Karnofsky)',
          text_long: '2 - Gehfähig, Selbstversorgung möglich, aber nicht arbeitsfähig; kann mehr als 50% der Wachzeit aufstehen (50 - 60 % nach Karnofsky)'
        },
        {
          value: 3,
          text: 'Nur begrenzte Selbstversorgung möglich; ist 50% oder mehr der Wachzeit an Bett oder Stuhl gebunden (30 - 40 % nach Karnofsky)',
          text_long: '3 - Nur begrenzte Selbstversorgung möglich; ist 50% oder mehr der Wachzeit an Bett oder Stuhl gebunden (30 - 40 % nach Karnofsky)'
        },
        {
          value: 4,
          text: 'Völlig pflegebedürftig, keinerlei Selbstversorgung möglich; völlig an Bett oder Stuhl gebunden (10 - 20% nach Karnofsky)',
          text_long: '4 - Völlig pflegebedürftig, keinerlei Selbstversorgung möglich; völlig an Bett oder Stuhl gebunden (10 - 20% nach Karnofsky)'
        }
      ],
      frequencyTypes: [
        {value: 'most', text: t('metadata.frequency_groups.most')},
        {value: 'average', text: t('metadata.frequency_groups.average')},
        {value: 'hardly', text: t('metadata.frequency_groups.hardly')}
      ],
      agentCategories: [
        {value: 'analgesia', text: t('metadata.categories.analgesia'), color: 'pink'},
        {value: 'antibiosis', text: t('metadata.categories.antibiosis'), color: 'blue'},
        {value: 'folinate', text: t('metadata.categories.folinate'), color: 'purple'},
        {value: 'antibody', text: t('metadata.categories.antibody'), color: 'green'},
        {value: 'antibody_zyto', text: t('metadata.categories.antibody_zyto'), color: 'orange'},
        {value: 'other', text: t('metadata.categories.other'), color: 'yellow'},
        {value: 'zyto', text: t('metadata.categories.zyto'), color: 'red'},
        {value: 'zytoralia', text: t('metadata.categories.zytoralia'), color: 'lime'}
      ],
      agentUnitValues: ['AUC', 'mg/m²', 'mg/kg', 'g', 'mg', 'µg', 'ml', 'mmol', 'I.E.', 'Mio. I.E.', 'µg/kg'],
      agentUnitValues2: [
        {value: 'AUC'},
        {value: 'mg/m²'},
        {value: 'mg/kg'},
        {value: 'g'},
        {value: 'mg'},
        {value: 'µg'},
        {value: 'ml'},
        {value: 'mmol'},
        {value: 'I.E.'},
        {value: 'Mio. I.E.'},
        {value: 'µg/kg'}
      ],
      agentUnitConvert: {
        'AUC': 'mg',
        'mg/m²': 'mg',
        'mg/kg': 'mg',
        'g': 'g',
        'mg': 'mg',
        'µg': 'µg',
        'ml': 'ml',
        'mmol': 'mmol',
        'I.E.': 'I.E.',
        'Mio. I.E.': 'Mio. I.E.',
        'µg/kg': 'µg'
      },
      checkCharactersPhone: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', '/', '+', '-', ' '],
      checkCharactersEmail: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', '@', '_', '-', '.'],
      daysOfWeek: [
        {value: 'monday', text: t('metadata.dayOfWeek.monday'), textShort: t('metadata.dayOfWeek.monday_short')},
        {value: 'tuesday', text: t('metadata.dayOfWeek.tuesday'), textShort: t('metadata.dayOfWeek.tuesday_short')},
        {value: 'wednesday', text: t('metadata.dayOfWeek.wednesday'), textShort: t('metadata.dayOfWeek.wednesday_short')},
        {value: 'thursday', text: t('metadata.dayOfWeek.thursday'), textShort: t('metadata.dayOfWeek.thursday_short')},
        {value: 'friday', text: t('metadata.dayOfWeek.friday'), textShort: t('metadata.dayOfWeek.friday_short')},
        {value: 'saturday', text: t('metadata.dayOfWeek.saturday'), textShort: t('metadata.dayOfWeek.saturday_short')},
        {value: 'sunday', text: t('metadata.dayOfWeek.sunday'), textShort: t('metadata.dayOfWeek.sunday_short')}
      ],
      defaultPageLimit: 50,
      defaultPageLimitList: [50, 100],
      icdPatternTypes: {
        tumor: 'C(?!77|78|79|97)|D(0|32|33|35$|35.[234]|37|38|39|4)|K50|K51|M05|M06',
        types_c_d: 'C|D|K50|K51|M05|M06',
        diagnoses: 'B|C|D|E|K50|K51|M05|M06|T80'
      },
      ICD10_Version: '10 2019 GM',
      infusionProtocolLineTypes: {
        AGENT: 'agent',
        MEDICATION: 'medication',
        CARRIER_SOLUTION: 'carrier_solution',
        TEXT: 'text'
      },
      sideLocalizationTypes: {
        L: 'Links',
        R: 'Rechts',
        B: 'Beidseitig',
        M: 'Mittellinie/mittig',
        U: 'Unbekannt',
        T: 'Trifft nicht zu'
      },
      sideLocalizationTypesPairedTumors: {
        L: 'Links',
        R: 'Rechts',
        B: 'Beidseitig'
      },
      pairedTumorList: ['C08.0', 'C08.1', 'C09.0', 'C09.1', 'C09.8', 'C09.9', 'C30.0', 'C30.1', 'C31.0', 'C31.2', 'C34.0', 'C34.1', 'C34.3', 'C34.8', 'C34.9', 'C38.4', 'C40.0', 'C40.1', 'C40.2', 'C40.3', 'C41.3', 'C41.4', 'C44.1', 'C44.2', 'C44.6', 'C44.7', 'C47.1', 'C47.2', 'C49.1', 'C49.2', 'C50.0', 'C50.1', 'C50.2', 'C50.3', 'C50.4', 'C50.5', 'C50.6', 'C50.8', 'C50.9', 'C57.0', 'C62.0', 'C62.1', 'C62.9', 'C63.0', 'C63.1', 'C69.0', 'C69.1', 'C69.2', 'C69.3', 'C69.4', 'C69.5', 'C69.6', 'C69.8', 'C69.9', 'C71.1', 'C71.2', 'C71.3', 'C71.4', 'C72.2', 'C72.3', 'C72.4', 'C74.0', 'C74.1', 'C74.9', 'C75.4'],
      pairedAdditionalTumors: {
        'C07': 'C07.9',
        'C43.1': 'C44.1',
        'C43.2': 'C44.2',
        'C43.6': 'C44.6',
        'C43.7': 'C44.7',
        'C56': 'C56.9',
        'C64': 'C64.9',
        'C65': 'C65.9',
        'C66': 'C66.9',
        'D05.0': 'C50.0',
        'D05.1': 'C50.1',
        'D05.7': 'C50.7',
        'D05.9': 'C50.9'
      },
      dateAccuracyLong: [
        {value: 'E', text: 'E - Exakt (entspricht taggenau)'},
        {value: 'T', text: 'T - Tag geschätzt (entspricht monatsgenau)'},
        {value: 'M', text: 'M - Monat geschätzt (entspricht jahrgenau)'},
        {value: 'V', text: 'V - Vollständig geschätzt (genaue Angabe zum Jahr nicht möglich)'}
      ],
      ICD10VersionTypes: [
        {value: '10 2024 GM', text: 'ICD 10 Version 2024 GM', misdValue: '2024'},
        {value: '10 2023 GM', text: 'ICD 10 Version 2023 GM', misdValue: '2023'},
        {value: '10 2022 GM', text: 'ICD 10 Version 2022 GM', misdValue: '2022'},
        {value: '10 2021 GM', text: 'ICD 10 Version 2021 GM', misdValue: '2021'},
        {value: '10 2020 GM', text: 'ICD 10 Version 2020 GM', misdValue: '2020'},
        {value: '10 2019 GM', text: 'ICD 10 Version 2019 GM', misdValue: '2019'},
        {value: '10 2018 GM', text: 'ICD 10 Version 2018 GM', misdValue: '2018'},
        {value: '10 2017 GM', text: 'ICD 10 Version 2017 GM', misdValue: '2017'},
        {value: '10 2016 GM', text: 'ICD 10 Version 2016 GM', misdValue: '2016'},
        {value: '10 2015 GM', text: 'ICD 10 Version 2015 GM', misdValue: '2015'},
        {value: '10 2014 GM', text: 'ICD 10 Version 2014 GM', misdValue: '2014'},
        {value: '10 2013 GM', text: 'ICD 10 Version 2013 GM', misdValue: '2013'},
        {value: '10 2012 GM', text: 'ICD 10 Version 2012 GM', misdValue: '2012'},
        {value: '10 2011 GM', text: 'ICD 10 Version 2011 GM', misdValue: '2011'},
        {value: '10 2010 GM', text: 'ICD 10 Version 2010 GM', misdValue: '2010'},
        {value: '10 2009 GM', text: 'ICD 10 Version 2009 GM', misdValue: '2009'},
        {value: '10 2008 GM', text: 'ICD 10 Version 2008 GM', misdValue: '2008'},
        {value: '10 2007 GM', text: 'ICD 10 Version 2007 GM', misdValue: '2007'},
        {value: '10 2006 GM', text: 'ICD 10 Version 2006 GM', misdValue: '2006'},
        {value: '10 2005 GM', text: 'ICD 10 Version 2005 GM', misdValue: '2005'},
        {value: '10 2004 GM', text: 'ICD 10 Version 2004 GM', misdValue: '2004'},
        {value: 'Sonstige', text: 'Sonstige'}
      ],
      therapyTypes: {
        therapy: 'therapy'
      },
      therapyGoalTypes: [
        {value: 'curative', text: 'kurativ'},
        {value: 'palliative', text: 'palliativ'},
        {value: 'supportive', text: 'supportiv'}
      ],
      therapyTypeTypes: [
        {value: 'adjuvant', text: 'adjuvant'},
        {value: 'neoadjuvant', text: 'neoadjuvant'},
        {value: 'consolidating', text: 'konsolidierend'}
      ],
      therapyLineTypes: [
        {value: 'first_line', text: 'first line'},
        {value: 'second_line', text: 'second line'},
        {value: 'third_line', text: 'third line'},
        {value: 'fourth_line', text: 'fourth line'}
      ],
      documentUploadTypesList: [
        {value: 'patient', text: t('component_patient_documents.document_types.patient')},
        {value: 'patient_informed_consent', text: t('component_patient_documents.document_types.patient_informed_consent')},
        {value: 'patient_informed_consent_medication', text: t('component_patient_documents.document_types.patient_informed_consent_medication')},
        //{ value: 'patient_schema', text: 'Patientenschema' }
      ],
      documentUploadTypesListBasicOrder: [
        {value: 'patient_informed_consent', text: t('component_patient_documents_basic_order.document_types.patient_informed_consent')},
      ],
      patientSchemaCloseReasonTypes: [
        {value: 'abort', text: t('component_patient_schema_therapy_plan.reason_type.abort')},
        {value: 'success', text: t('component_patient_schema_therapy_plan.reason_type.success')},
        {value: 'fail', text: t('component_patient_schema_therapy_plan.reason_type.fail')},
        {value: 'death', text: t('component_patient_schema_therapy_plan.reason_type.death')}
      ],
      patientSchemaCloseReasonTypesEdit: [
        {value: 'abort', text: t('popup_close_patient_schema.reason_type.abort')},
        {value: 'success', text: t('popup_close_patient_schema.reason_type.success')},
        {value: 'fail', text: t('popup_close_patient_schema.reason_type.fail')}
      ],
      therapyActions: {
        DELETE: 'delete',
        CANCEL: 'cancel',
        ORDER: 'order',
        APPROVE: 'approve',
        APPLY: 'apply'
      },
      workflowStates: {
        physician: {
          planned: 10,
          approved: 20,
          ordered: 30,
          ordered_inactive_partner: 31,
          rejected_by_pharmacy: 35,
          manufactured: 40,
          canceled: 50,
          revoked_by_pharmacy: 60,
          is_read: 65,
          shipped: 70,
          delivered: 80,
          applied: 90
        }
      },
      workflowTabStates: {
        physician: {
          TAB_STATUS_PLANNED: [
            {value: 'planned', text: t('workflow_states.physician.planned')},
            {value: 'approved', text: t('workflow_states.physician.approved')}
          ],
          TAB_STATUS_ORDERED: [
            {value: 'ordered', text: t('workflow_states.physician.ordered')},
            {value: 'ordered_inactive_partner', text: t('workflow_states.physician.ordered_inactive_partner2')},
            {value: 'rejected_by_pharmacy', text: t('workflow_states.physician.rejected_by_pharmacy')},
            {value: 'manufactured', text: t('workflow_states.physician.manufactured')},
            {value: 'is_read', text: t('workflow_states.physician.is_read')},
            {value: 'shipped', text: t('workflow_states.physician.shipped')},
            {value: 'delivered', text: t('workflow_states.physician.delivered')}
          ],
          TAB_STATUS_FINISHED: [
            {value: 'canceled', text: t('workflow_states.physician.canceled')},
            {value: 'revoked_by_pharmacy', text: t('workflow_states.physician.revoked_by_pharmacy')},
            {value: 'applied', text: t('workflow_states.physician.applied')}
          ],
          TAB_PATIENT_THERAPIES: [
            {value: 'planned', text: t('workflow_states.physician.planned')},
            {value: 'approved', text: t('workflow_states.physician.approved')},
            {value: 'ordered', text: t('workflow_states.physician.ordered')},
            {value: 'ordered_inactive_partner', text: t('workflow_states.physician.ordered_inactive_partner2')},
            {value: 'rejected_by_pharmacy', text: t('workflow_states.physician.rejected_by_pharmacy')},
            {value: 'manufactured', text: t('workflow_states.physician.manufactured')},
            {value: 'is_read', text: t('workflow_states.physician.is_read')},
            {value: 'shipped', text: t('workflow_states.physician.shipped')},
            {value: 'delivered', text: t('workflow_states.physician.delivered')},
            {value: 'canceled', text: t('workflow_states.physician.canceled')},
            {value: 'revoked_by_pharmacy', text: t('workflow_states.physician.revoked_by_pharmacy')},
            {value: 'applied', text: t('workflow_states.physician.applied')}
          ]
        }
      },
      therapies: {
        tabStates: {
          TAB_STATUS_PLANNED: 'planned',
          TAB_STATUS_ORDERED: 'ordered',
          TAB_STATUS_FINISHED: 'finished'
        }
      },
      orders: {
        tabStates: {
          TAB_STATUS_ORDERED: 'ordered',
          TAB_STATUS_FINISHED: 'finished'
        }
      },
      pharmacyPartnerTypes: {
        ActivePharmacy: 'active_pharmacy',
        SimpleMode: 'simple_mode',
        InactivePharmacy: 'inactive_pharmacy',
      },
      basicOrderStates: {
        CREATED: 'created',
        APPROVED: 'approved',
        ORDERED: 'ordered'
      },
      therapyTemperaturesTypes: {
        0: '2 - 25 °C',
        1: '2 - 8 °C',
        2: '15 - 25 °C'
      }
    }

    app.provide('$formsMetaData', formsMetaData)
  }
}
